module.exports = __webpack_public_path__ + "img/rarity-element.5ea69df2.png";